import AnalyticsEventName from './analyticsEventName';
import track from './track';

const trackSocialAuthLoginClick = (network: string) => {
    track(AnalyticsEventName.SIGNED_IN, {
        type: network.toLowerCase(),
    });
};

const initTrackSocialAuthLoginClick = () => {
    const loginLinks = document.querySelectorAll<HTMLElement>('.social-auth');
    loginLinks.forEach((loginLink) => {
        if (typeof loginLink.dataset?.network === 'undefined') {
            return;
        }
        if (typeof loginLink.dataset.heapEventAdded !== 'undefined') {
            return;
        }
        // eslint-disable-next-line no-param-reassign
        loginLink.dataset.heapEventAdded = '1';
        loginLink.addEventListener('click', () => trackSocialAuthLoginClick(loginLink.dataset.network as string));
    });
};

export default initTrackSocialAuthLoginClick;
